import { get } from "lodash";
import { useSelectedPatientStore } from "@/stores/selected-patient";
import { useWorkspaces } from "@/hooks/use-workspaces";

/** Active EMR identifiers for the currently selected patient. */

/** Resolves the workspace id, patient uid, first name, and contact number from the selected patient. */
export function useEmrContext() {
  var selectedPatient = useSelectedPatientStore(function (s) {
    return s.selectedPatient;
  });
  var patientUid = get(selectedPatient, "patient_uid", 0);
  var sourceId = get(selectedPatient, "source_id", "");
  var patientFirstName = (get(selectedPatient, ["additional", "patient_name", "first"], "") || String(get(selectedPatient, "name", "")).trim().split(" ")[0] || "").trim();
  var patientNumber = String(get(selectedPatient, "contact", "") || "").trim();
  var _useWorkspaces = useWorkspaces(),
    workspaces = _useWorkspaces.data;
  var workspaceId = get(workspaces === null || workspaces === void 0 ? void 0 : workspaces.find(function (workspace) {
    return workspace.uuid === sourceId;
  }), "id", 0);
  return {
    workspaceId: workspaceId,
    patientUid: patientUid,
    patientFirstName: patientFirstName,
    patientNumber: patientNumber
  };
}